/* eslint-disable max-len */
export const FETCH_POINTS = 'SETTINGS:NOTIFICATIONS:FETCH_HOME_POINTS';
export const FETCH_POINTS_SUCCESS = 'SETTINGS:NOTIFICATIONS:FETCH_HOME_POINTS_SUCCESS';
export const FETCH_POINTS_ERROR = 'SETTINGS:NOTIFICATIONS:FETCH_HOME_POINTS_ERROR';

export const TOGGLE_NOTIFICATION_POINT = 'SETTINGS:NOTIFICATIONS:TOGGLE_HOME_NOTIFICATION_POINT';
export const TOGGLE_NOTIFICATION_POINT_SUCCESS = 'SETTINGS:NOTIFICATIONS:TOGGLE_HOME_NOTIFICATION_POINT_SUCCESS';
export const TOGGLE_NOTIFICATION_POINT_ERROR = 'SETTINGS:NOTIFICATIONS:TOGGLE_HOME_NOTIFICATION_POINT_ERROR';

export const SAVE_NOTIFICATION_POINT = 'SETTINGS:NOTIFICATIONS:SAVE_HOME_NOTIFICATION_POINT';
export const SAVE_NOTIFICATION_POINT_SUCCESS = 'SETTINGS:NOTIFICATIONS:SAVE_HOME_NOTIFICATION_POINT_SUCCESS';
export const SAVE_NOTIFICATION_POINT_ERROR = 'SETTINGS:NOTIFICATIONS:SAVE_HOME_NOTIFICATION_POINT_ERROR';

export const CONFIRM_NOTIFICATION_POINT_CODE = 'SETTINGS:NOTIFICATIONS:CONFIRM_HOME_NOTIFICATION_POINT_CODE';
export const CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS = 'SETTINGS:NOTIFICATIONS:CONFIRM_HOME_NOTIFICATION_POINT_CODE_SUCCESS';
export const CONFIRM_NOTIFICATION_POINT_CODE_ERROR = 'SETTINGS:NOTIFICATIONS:CONFIRM_HOME_NOTIFICATION_POINT_CODE_ERROR';

export const SEND_NOTIFICATION_POINT_CODE = 'SETTINGS:NOTIFICATIONS:SEND_HOME_NOTIFICATION_POINT_CODE';
export const SEND_NOTIFICATION_POINT_CODE_SUCCESS = 'SETTINGS:NOTIFICATIONS:SEND_HOME_NOTIFICATION_POINT_CODE_SUCCESS';
export const SEND_NOTIFICATION_POINT_CODE_ERROR = 'SETTINGS:NOTIFICATIONS:SEND_HOME_NOTIFICATION_POINT_CODE_ERROR';

export const TOGGLE_POINT_EDITING_STATE = 'SETTINGS:NOTIFICATIONS:TOGGLE_HOME_POINT_EDITING_STATE';

export const TOGGLE_CONFIRMATION_CODE_POPUP = 'SETTINGS:NOTIFICATIONS:TOGGLE_HOME_CONFIRMATION_CODE_POPUP';

export const RESET_NOTIFICATION_POINT_CODE_VALIDATION = 'SETTINGS:NOTIFICATIONS:RESET_HOME_NOTIFICATION_POINT_CODE_VALIDATION';

export const CONFIRMATION_POPUP_KEY = 'SETTINGS:NOTIFICATIONS:CONFIRMATION';
export const EDITING_POPUP_KEY = 'SETTINGS:NOTIFICATIONS:EDITING';
